/**
 * Created by qlong on 9/12/2016.
 */
import helper from "../Helper.js"

// Set the initial state for line chart
const initialState = {
    max_series: 5,
    filterGridData: {},
    visibleIndexes: [],
    colors: {},
    colorSet: helper.getInitialColorSet(10, 1),
    colorSetStatic: helper.getInitialColorSet(10, 1),
}

export default function reducer(state=initialState,action){
        switch (action.type){
            case "RESET_FILTER_GRID": // No series currently visible
                return initialState
            case "ADD_FILTER_GRID_DATA":
                return {...state, filterGridData: action.payload}
            case "SET_COLOR":
                return {...state, colors: {...state.colors, [action.payload.index]: action.payload.color }}
            case "DELETE_COLOR":
                return helper.deleteObjectAttribute(state, action, "colors")
            case "ADD_COLOR_SET":
                return {...state, colorSet: [action.payload].concat([...state.colorSet])}
            case "POP_COLOR_SET":
                return {...state, colorSet: [...state.colorSet.slice(1)]}
            case "ADD_VISIBLE_INDEXES":
                return {...state, visibleIndexes: [...state.visibleIndexes, action.payload]}
            case "REMOVE_VISIBLE_INDEXES":
                return {...state, visibleIndexes: [...state.visibleIndexes.filter((item) => item != action.payload)]}
        }

        return state
    }


/** WEBPACK FOOTER **
 ** ./src/reducers/filterGridReducer.js
 **/